import React from 'react'
import Header from '../components/Header'
import RequestDemo from '../components/RequestDemo'
import { Helmet } from 'react-helmet'

export default function WebRequestDemo() {
  return (
    <div className='requestDemoBgImg'>
                  <Helmet>
        <title>Features | Andromeda</title>
        <meta name="description" content="Get in touch with us through our contact page." />
        <meta name="keywords" content="contact, support, help, andromeda sim" />
      </Helmet>
        <div className=''><Header/></div>
        <RequestDemo/>
    </div>
  )
}
